// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "primeui." + {"241":"c67c8800715bab62e38b","466":"46713e76bb826d0d7ff3","483":"cbf59c6c306520e31a17","620":"5159dc4024049c73f035","726":"ffc23368c31acf3c8030","762":"3a0f49c4fda4eb6112b9","985":"1a90cd07fe8aec7c15fd"}[chunkId] + ".css";
};